import { QueryClient } from '@tanstack/react-query';

import { DEFAULT_QUERY_OPTIONS } from './api';

/**
 * The module's one cache.
 *
 * It lives here rather than beside an entry point because both kinds of caller need it: the trees,
 * through `ModuleProviders`, and the thirty-five `src/api` modules that invalidate imperatively
 * after a mutation. Two clients meant those two halves spoke past each other -- a mutation
 * invalidated one cache while the screen rendered from the other, and nothing refreshed.
 */
export const queryClient = new QueryClient({
    defaultOptions: { queries: DEFAULT_QUERY_OPTIONS },
});
